/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from "react";
import { SystemUserConfirmationTitles, SystemUserStatusCssClasses } from "../../SystemUsersUIHelpers";

export const ConfirmationColumnFormatter = (cellContent, row) => (
  <span
    className={`label label-lg label-light-${
      SystemUserStatusCssClasses[row.isSuperAdmin]
    } label-inline`}
  >
    {SystemUserConfirmationTitles[row.isSuperAdmin]}
  </span>
);